import { SET_SECTORS } from './types';

export function addSectors(sectors: []) {
  return {
    type: SET_SECTORS,
    payload: sectors,
  };
}
